// extracted by mini-css-extract-plugin
module.exports = {"main-component":"newActions_main-component__1tvMO"};